import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

import { VersionResponseSchema } from './schemas.js';

export const getVersions = defaultApi.declareEndpoint({
  url: 'datintell/v1/builder/media_plan_versions' as const,
  method: 'GET',
  responseSchema: z.array(VersionResponseSchema),
  querySchema: z.object({
    mediaPlanId: z.number(),
  }),
});

export type VersionsResponseType = z.infer<typeof VersionResponseSchema>;

export const getVersionsQueryOptions = makeQueryOptions(getVersions, {
  processResponse(data) {
    return data;
  },
});

export const createNewVersion = defaultApi.declareEndpoint({
  url: 'datintell/v1/builder/media_plan_versions/:id/duplicate/' as const,
  method: 'PUT',
  responseSchema: VersionResponseSchema,
  requestSchema: z.object({
    id: z.number(),
  }),
});
